<template>
<div>
  <component :is="'default'"/>
</div>
</template>

<script>
import axios from 'axios'

import basic from './default.vue';

export default {
  name: 'private-response',
  components: {default: basic},
  created() {
    axios.get(`1.0/templates/defaults/share_response_link`)
      .then(r => {
        // this.share_template = r.data.data[0];
      })
  }
}
</script>

<style scoped>
</style>